"use strict";
// tslint:disable:no-identical-functions
/**
 * Card Service file
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CardService_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardService = void 0;
const cardinal_sandbox_js_1 = require("@kushki/cardinal-sandbox-js");
const buffer_1 = require("buffer");
const Identifiers_1 = require("./../../lib/constant/Identifiers");
const dot = require("dot-object");
const KushkiError_1 = require("./../../lib/generic/KushkiError");
const CardinalValidated_1 = require("./../../lib/infrastructure/CardinalValidated");
const ErrorEnum_1 = require("./../../lib/infrastructure/ErrorEnum");
const ThreeDSEnum_1 = require("./../../lib/infrastructure/ThreeDSEnum");
const inversify_1 = require("inversify");
require("reflect-metadata");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const UtilsService_1 = require("./../../lib/service/UtilsService");
const Kushki_1 = require("./../../lib/Kushki");
let CardService = CardService_1 = class CardService {
    constructor(gateway, authService, antiFraud) {
        this._3Dsecure = "active_3dsecure";
        this._cardNumber = "card.number";
        this._sandboxEnable = false;
        this._gateway = gateway;
        this._antiFraud = antiFraud;
        this._authService = authService;
        this._receipt = {
            amount: "totalAmount",
            "card.cvc": "card.cvv",
            "card.expiryMonth": "card.expiryMonth",
            "card.expiryYear": "card.expiryYear",
            "card.name": "card.name",
            [this._cardNumber]: this._cardNumber,
            currency: "currency",
            emailRequest: "email",
            isDeferred: "isDeferred",
            jwt: "jwt",
            merchantName: "merchantName",
            months: "months",
            savePaymentData: "savePaymentData",
            sessionId: "sessionId",
            userId: "userId",
            walletId: "walletId",
        };
    }
    requestToken(request, mid, isTest, regional, callback) {
        this._gateway
            .requestMerchantSettings(mid, isTest, regional)
            .pipe(operators_1.switchMap((merchant) => {
            this._setSandboxEnable(!!merchant.sandboxEnable);
            return rxjs_1.forkJoin([
                this._getScienceSession(request, mid, isTest, merchant),
                this._getCybersourceJwt(merchant, mid, isTest, regional, Object.prototype.hasOwnProperty.call(request, "card")
                    ? request.card.number
                    : undefined),
                rxjs_1.of(merchant),
            ]);
        }), operators_1.mergeMap(([sift_object, jwt, merchant]) => {
            request.isDeferred =
                request.isDeferred === undefined ? false : request.isDeferred;
            if (Boolean(request.cvv))
                request.card = { cvc: request.cvv };
            this._checkRequestBody(request);
            const data_to_transform = Object.assign(Object.assign({}, request), sift_object);
            if (jwt !== undefined)
                data_to_transform.jwt = jwt;
            return rxjs_1.forkJoin([
                rxjs_1.of(dot.transform(this._receipt, Object.assign(Object.assign({}, data_to_transform), { merchantName: merchant.merchant_name }))),
                request.walletId
                    ? this._authService.getAuthorizationToken()
                    : rxjs_1.of(undefined),
                rxjs_1.of(merchant),
            ]);
        }))
            .subscribe({
            error: (err) => Kushki_1.Kushki.callbackError(err, callback),
            next: ([final_request, authorization, merchant]) => {
                if (final_request.jwt && !merchant.sandboxEnable)
                    this._request3DSToken(isTest, () => {
                        this._requestTokenGateway(final_request, mid, isTest, regional, callback, authorization);
                    });
                else
                    this._requestTokenGateway(final_request, mid, isTest, regional, callback, authorization);
            },
        });
    }
    requestDeviceToken(request, mid, isTest, regional, callback) {
        this._gateway
            .requestMerchantSettings(mid, isTest, regional)
            .pipe(operators_1.switchMap((merchant) => {
            this._setSandboxEnable(!!merchant.sandboxEnable);
            return rxjs_1.forkJoin([
                this._getDeviceTokenSiftScienceObject(request, mid, isTest, merchant, regional),
                this._getCybersourceJwtSubscription(merchant, mid, isTest, regional, request.subscriptionId),
            ]);
        }))
            .subscribe({
            error: (err) => Kushki_1.Kushki.callbackError(err, callback),
            next: ([sift_science_obj, jwt]) => {
                if (sift_science_obj.userId === null)
                    delete sift_science_obj.userId;
                if (sift_science_obj.sessionId === null)
                    delete sift_science_obj.sessionId;
                if (jwt && !this._sandboxEnable) {
                    sift_science_obj = Object.assign(Object.assign({}, sift_science_obj), { jwt, amount: request.amount, cardHolderName: request.cardHolderName, currency: request.currency });
                    this._request3DSToken(isTest, () => {
                        sift_science_obj = Object.assign(Object.assign({}, sift_science_obj), { jwt });
                        this._requestDeviceToken(Object.assign({ subscriptionId: request.subscriptionId }, sift_science_obj), mid, isTest, regional, callback);
                    });
                }
                else {
                    sift_science_obj = Object.assign(Object.assign({}, sift_science_obj), { jwt });
                    this._requestDeviceToken(Object.assign({ subscriptionId: request.subscriptionId }, sift_science_obj), mid, isTest, regional, callback);
                }
            },
        });
    }
    requestSubscriptionToken(subscriptionTokenRequest, mid, isTest, regional, callback) {
        this._gateway
            .requestMerchantSettings(mid, isTest, regional)
            .pipe(operators_1.switchMap((merchant) => {
            this._setSandboxEnable(!!merchant.sandboxEnable);
            return rxjs_1.forkJoin([
                this._getScienceSession(subscriptionTokenRequest, mid, isTest, merchant),
                this._getCybersourceJwt(merchant, mid, isTest, regional, UtilsService_1.UtilsService.sGet(subscriptionTokenRequest, this._cardNumber)),
                rxjs_1.of(merchant),
            ]);
        }), operators_1.mergeMap(([sift_object, jwt, merchant]) => {
            this._checkRequestBody(subscriptionTokenRequest);
            const data_to_transform = this._getCreateSubscriptionDataToTransform(sift_object, subscriptionTokenRequest);
            if (jwt !== undefined)
                data_to_transform.jwt = jwt;
            return rxjs_1.forkJoin([
                rxjs_1.of(dot.transform(this._receipt, Object.assign(Object.assign({}, data_to_transform), { merchantName: merchant.merchant_name }))),
                subscriptionTokenRequest.walletId
                    ? this._authService.getAuthorizationToken()
                    : rxjs_1.of(undefined),
                rxjs_1.of(merchant),
            ]);
        }))
            .subscribe({
            error: (err) => Kushki_1.Kushki.callbackError(err, callback),
            next: ([body, jwt, merchant]) => {
                if (body.jwt && !merchant.sandboxEnable)
                    this._request3DSToken(isTest, () => {
                        this._requestSubscriptionTokenGateway(body, mid, isTest, regional, callback, jwt);
                    });
                else
                    this._requestSubscriptionTokenGateway(body, mid, isTest, regional, callback, jwt);
            },
        });
    }
    requestDeferred(binBody, mid, isTest, regional) {
        return this._gateway.requestDeferredConditions(mid, binBody.bin, isTest, regional);
    }
    requestBinInfo(binBody, mid, isTest, regional) {
        return this._gateway.requestBinInfo(mid, UtilsService_1.getBinFromCreditCardNumber(String(binBody.bin)), isTest, regional);
    }
    validate3DS(body, mid, isTest, regional, callback) {
        // tslint:disable-next-line
        if (body.security === undefined)
            return Kushki_1.Kushki.callbackError(new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS.E012), callback);
        if (!UtilsService_1.UtilsService.sGet(body, "security.authRequired", false)) {
            callback({ isValid: true });
            return;
        }
        if (UtilsService_1.UtilsService.sGet(body, "security.authRequired") &&
            this._validateParameters(body))
            return Kushki_1.Kushki.callbackError(new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS.E012), callback);
        if (this._sandboxEnable ||
            UtilsService_1.UtilsService.sGet(body, "security.paReq", ThreeDSEnum_1.ThreeDSEnum.SANDBOX) ===
                ThreeDSEnum_1.ThreeDSEnum.SANDBOX)
            return this._ccaSandbox(body, mid, isTest, regional, callback);
        if (this._isInvalidSpecificationVersion(body, this._sandboxEnable))
            return Kushki_1.Kushki.callbackError(new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS.E012), callback);
        if (isTest) {
            // tslint:disable-next-line:no-duplicate-string
            Promise.resolve().then(() => require("./../../lib/libs/cardinal/staging")).then(() => {
                CardService_1._ccaCardinal(body);
            });
            Promise.resolve().then(() => require("./../../lib/libs/cardinal/staging")).then(() => {
                this._completeCardinal(body.secureId, mid, isTest, regional, callback);
            });
        }
        else {
            // tslint:disable-next-line:no-duplicate-string
            Promise.resolve().then(() => require("./../../lib/libs/cardinal/prod")).then(() => {
                CardService_1._ccaCardinal(body);
            });
            Promise.resolve().then(() => require("./../../lib/libs/cardinal/prod")).then(() => {
                this._completeCardinal(body.secureId, mid, isTest, regional, callback);
            });
        }
    }
    requestSecureInit(request, mid, isTest, regional, callback) {
        rxjs_1.of(1)
            .pipe(operators_1.map(() => this._checkSecureInitCardLength(request)), operators_1.switchMap(() => this._getMerchantSettings(mid, isTest, regional)), operators_1.switchMap((merchantSettings) => rxjs_1.iif(() => this._is3DSSecureEnabled(merchantSettings), rxjs_1.of(merchantSettings), rxjs_1.throwError(new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS.E013)))), operators_1.switchMap((merchant) => rxjs_1.forkJoin(this._getCybersourceJwt(merchant, mid, isTest, regional, request.card.number), rxjs_1.of(merchant))))
            .subscribe({
            error: (err) => Kushki_1.Kushki.callbackError(err, callback),
            next: ([jwt_response, merchant_settings]) => {
                const jwt = { jwt: jwt_response };
                if (this._isSandboxEnabled(merchant_settings)) {
                    callback(jwt);
                    return;
                }
                this._request3DSToken(isTest, () => {
                    callback(jwt);
                });
            },
        });
    }
    _getCreateSubscriptionDataToTransform(siftObject, subscriptionTokenRequest) {
        if (siftObject.userId === null || siftObject.sessionId === null)
            return Object.assign({}, subscriptionTokenRequest);
        return Object.assign(Object.assign({}, subscriptionTokenRequest), siftObject);
    }
    _request3DSToken(isTest, callback) {
        if (isTest)
            Promise.resolve().then(() => require("./../../lib/libs/cardinal/staging")).then(() => {
                this._setupCompleteCardinal(callback);
            });
        else
            Promise.resolve().then(() => require("./../../lib/libs/cardinal/prod")).then(() => {
                this._setupCompleteCardinal(callback);
            });
    }
    // istanbul ignore next
    _setupCompleteCardinal(callback) {
        window.Cardinal.on("payments.setupComplete", () => __awaiter(this, void 0, void 0, function* () {
            callback();
        }));
    }
    // istanbul ignore next
    _requestTokenGateway(body, mid, testEnv, regional, callback, authorization) {
        const request_token = this._gateway.requestToken(body, mid, testEnv, regional, authorization);
        return request_token.subscribe({
            error: (err) => Kushki_1.Kushki.callbackError(err, callback),
            next: (response) => {
                callback(response);
            },
        });
    }
    _getMerchantSettings(mid, isTest, regional) {
        return this._gateway.requestMerchantSettings(mid, isTest, regional).pipe(operators_1.map((merchant) => {
            this._setSandboxEnable(!!merchant.sandboxEnable);
            return merchant;
        }));
    }
    _validateParameters(body) {
        return (body.security.acsURL === undefined ||
            body.security.paReq === undefined ||
            body.security.authenticationTransactionId === undefined);
    }
    _getDeviceTokenSiftScienceObject(request, mid, isTest, merchant, regional) {
        return rxjs_1.of(1).pipe(operators_1.switchMap(() => rxjs_1.iif(() => request.sessionId !== undefined &&
            request.sessionId !== null &&
            (request.userId !== undefined && request.userId !== null), this._getRequestSiftObject(request.userId, request.sessionId), this._createSubscriptionSiftScienceSession(request.subscriptionId, mid, isTest, merchant, regional, request))));
    }
    _createSubscriptionSiftScienceSession(subscriptionId, mid, isTest, merchantSettingsResponse, regional, request) {
        return rxjs_1.of(1).pipe(operators_1.switchMap(() => this._getUserId(subscriptionId, mid, isTest, regional, request.userId)), operators_1.switchMap((getUserIdResponse) => this._antiFraud.createSiftScienceSession(subscriptionId, "", mid, isTest, merchantSettingsResponse, UtilsService_1.UtilsService.sGet(getUserIdResponse, "userId"))));
    }
    _checkCardLength(request) {
        if (request.card.number.length < 14 || request.card.number.length > 19)
            throw new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS[ErrorEnum_1.ErrorCode.E005]);
    }
    _checkSecureInitCardLength(request) {
        if (request.card.number.length < 6 || request.card.number.length > 19)
            throw new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS[ErrorEnum_1.ErrorCode.E014]);
    }
    _getScienceSession(request, mid, isTest, merchant) {
        return rxjs_1.of(1).pipe(operators_1.switchMap(() => {
            if (request.card && request.card.number !== undefined)
                return this._antiFraud.createSiftScienceSession(UtilsService_1.getBinFromCreditCardNumberSift(request.card.number), request.card.number.slice(-4), mid, isTest, merchant);
            return rxjs_1.of({
                sessionId: null,
                userId: null,
            });
        }));
    }
    _checkCurrency(request) {
        request.currency =
            request.currency === undefined ? "USD" : request.currency;
    }
    _getRequestSiftObject(userId, sessionId) {
        return rxjs_1.of(1).pipe(operators_1.map(() => ({
            sessionId,
            userId,
        })));
    }
    _checkAmount(request) {
        if (request.amount !== undefined && typeof request.amount === "string")
            request.amount = parseFloat(request.amount);
    }
    _checkRequestBody(request) {
        this._checkCurrency(request);
        if (Boolean(request.card) && Boolean(request.card.number))
            this._checkCardLength(request);
        this._checkAmount(request);
    }
    _getCybersourceJwt(merchantSettings, mid, isTest, regional, cardNumber) {
        return rxjs_1.of(1).pipe(operators_1.switchMap(() => {
            if (this._is3DSSecureEnabled(merchantSettings) &&
                cardNumber !== undefined &&
                !UtilsService_1.UtilsService.sIsEmpty(window))
                return rxjs_1.iif(() => this._isSandboxEnabled(merchantSettings), this._initCybersourceSandbox(mid, isTest, regional), this._initCybersource(cardNumber, mid, isTest, regional));
            return rxjs_1.of(undefined);
        }));
    }
    _isSandboxEnabled(merchantSettings) {
        return !!merchantSettings.sandboxEnable;
    }
    _getCybersourceJwtSubscription(merchantSettings, mid, isTest, regional, subscriptionId) {
        return rxjs_1.of(1).pipe(operators_1.switchMap(() => {
            if (this._is3DSSecureEnabled(merchantSettings) &&
                !UtilsService_1.UtilsService.sIsEmpty(window))
                return rxjs_1.iif(() => this._isSandboxEnabled(merchantSettings), this._initCybersourceSandbox(mid, isTest, regional), this._initCybersourceSubscription(subscriptionId, mid, isTest, regional));
            return rxjs_1.of(undefined);
        }));
    }
    _is3DSSecureEnabled(merchantSettings) {
        return merchantSettings[this._3Dsecure] === true;
    }
    _initCybersource(cardNumber, mid, isTest, regional) {
        return rxjs_1.of(1).pipe(operators_1.switchMap(() => this._gateway.cybersourceJwt(mid, isTest, regional)), operators_1.map((jwtResponse) => {
            this._initializeCardinal(isTest, jwtResponse.jwt, cardNumber);
            return jwtResponse.jwt;
        }));
    }
    _initializeCardinal(isTest, jwt, identifier) {
        if (isTest)
            Promise.resolve().then(() => require("./../../lib/libs/cardinal/staging")).then(() => {
                CardService_1._initCardinal(jwt, identifier);
            });
        else
            Promise.resolve().then(() => require("./../../lib/libs/cardinal/prod")).then(() => {
                CardService_1._initCardinal(jwt, identifier);
            });
    }
    _initCybersourceSubscription(subscriptionId, mid, isTest, regional) {
        return rxjs_1.of(1).pipe(operators_1.switchMap(() => this._gateway.cybersourceJwt(mid, isTest, regional, subscriptionId)), operators_1.map((jwtResponse) => {
            const bin = buffer_1.Buffer.from(jwtResponse.identifier, "base64").toString("ascii");
            this._initializeCardinal(isTest, jwtResponse.jwt, bin);
            return jwtResponse.jwt;
        }));
    }
    // istanbul ignore next
    _completeCardinal(secureServiceId, mid, isTest, regional, callback) {
        return window.Cardinal.on("payments.validated", (data) => __awaiter(this, void 0, void 0, function* () {
            if (data.ActionCode === CardinalValidated_1.ActionCodeEnum.FAIL && !data.Validated)
                return Kushki_1.Kushki.callbackError(new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS.E012), callback);
            const otp_request = {
                secureServiceId,
                otpValue: "",
            };
            const secure = this._gateway.requestSecureServiceValidation(mid, otp_request, isTest, regional);
            return secure.subscribe({
                error: (err) => Kushki_1.Kushki.callbackError(err, callback),
                next: (response) => {
                    callback({
                        isValid: CardService_1._is3dsValid(response),
                    });
                },
            });
        }));
    }
    static _initCardinal(jwt, cardNumber) {
        window.Cardinal.setup("init", {
            jwt,
            order: {
                Consumer: {
                    Account: {
                        AccountNumber: UtilsService_1.getBinFromCreditCardNumber(cardNumber),
                    },
                },
            },
        });
    }
    static _ccaCardinal(tokenResponse) {
        window.Cardinal.continue("cca", {
            AcsUrl: tokenResponse.security.acsURL,
            Payload: tokenResponse.security.paReq,
        }, {
            OrderDetails: {
                TransactionId: tokenResponse.security.authenticationTransactionId,
            },
        });
    }
    // istanbul ignore next
    static _is3dsValid(secureOtpResponse) {
        return ("message" in secureOtpResponse &&
            ((secureOtpResponse.message === "3DS000" &&
                secureOtpResponse.code === "ok") ||
                (secureOtpResponse.code === "3DS000" &&
                    secureOtpResponse.message === "ok")));
    }
    _setSandboxEnable(payload) {
        this._sandboxEnable = payload;
    }
    _initCybersourceSandbox(mid, isTest, regional) {
        return rxjs_1.of(1).pipe(operators_1.switchMap(() => this._gateway.cybersourceJwt(mid, isTest, regional)), operators_1.map((jwtResponse) => {
            cardinal_sandbox_js_1.KushkiCardinalSandbox.init();
            return jwtResponse.jwt;
        }));
    }
    _ccaSandbox(body, mid, isTest, regional, callback) {
        cardinal_sandbox_js_1.KushkiCardinalSandbox.continue("cca", {
            AcsUrl: body.security.acsURL,
            Payload: body.security.paReq,
        }, {
            OrderDetails: {
                TransactionId: body.security.authenticationTransactionId,
            },
        });
        // istanbul ignore next
        cardinal_sandbox_js_1.KushkiCardinalSandbox.on("payments.validated", (isErrorFlow) => __awaiter(this, void 0, void 0, function* () {
            if (isErrorFlow === true)
                return Kushki_1.Kushki.callbackError(new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS.E008), callback);
            const otp_request = {
                otpValue: "",
                secureServiceId: body.secureId,
            };
            const secure = this._gateway.requestSecureServiceValidation(mid, otp_request, isTest, regional);
            return secure.subscribe({
                error: (err) => Kushki_1.Kushki.callbackError(err, callback),
                next: (response) => callback({
                    isValid: CardService_1._is3dsValid(response),
                }),
            });
        }));
    }
    _getUserId(subscriptionId, mid, testEnv, regional, userId) {
        return rxjs_1.of(1).pipe(operators_1.switchMap(() => rxjs_1.iif(() => UtilsService_1.UtilsService.sIsEmpty(userId), this._gateway.getUserId(subscriptionId, mid, testEnv, regional), rxjs_1.of(undefined))), operators_1.catchError(() => rxjs_1.of(undefined)));
    }
    _requestSubscriptionTokenGateway(body, mid, testEnv, regional, callback, authorization) {
        this._gateway
            .requestSubscriptionToken(body, mid, testEnv, regional, authorization)
            .subscribe({
            error: (err) => Kushki_1.Kushki.callbackError(err, callback),
            next: (response) => {
                callback(response);
            },
        });
    }
    _requestDeviceToken(body, mid, testEnv, regional, callback) {
        this._gateway.requestDeviceToken(body, mid, testEnv, regional).subscribe({
            error: (err) => Kushki_1.Kushki.callbackError(err, callback),
            next: (response) => {
                callback(response);
            },
        });
    }
    _isInvalidSpecificationVersion(body, sandboxEnabled) {
        const is_invalid_version = body.security.specificationVersion !== undefined &&
            body.security.specificationVersion.startsWith("1.");
        return is_invalid_version && !sandboxEnabled;
    }
};
CardService = CardService_1 = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(Identifiers_1.IDENTIFIERS.KushkiGateway)),
    __param(1, inversify_1.inject(Identifiers_1.IDENTIFIERS.AuthService)),
    __param(2, inversify_1.inject(Identifiers_1.IDENTIFIERS.AntiFraud)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CardService);
exports.CardService = CardService;
